import request from '@/utils/request'

export function getData(data) {
    return request({
        url: '/backend/activity/assist/getData',
        method: 'post',
        data: data
    })
}

export function getList(data) {
    return request({
        url: '/backend/activity/assist/list',
        method: 'post',
        data: data
    })
}

export function getAssistDataList(data) {
    return request({
        url: '/backend/activity/assist/dataList',
        method: 'post',
        data: data
    })
}

export function getUserDataList(data) {
    return request({
        url: '/backend/activity/assist/userList',
        method: 'post',
        data: data
    })
}

export function getLockBagList(data) {
    return request({
        url: '/backend/activity/assist/lockBagList',
        method: 'post',
        data: data
    })
}

export function createAssist(data) {
    return request({
        url: '/backend/activity/assist/create',
        method: 'post',
        data: data
    })
}

export function getAssistInfo(data) {
    return request({
        url: '/backend/activity/assist/info',
        method: 'post',
        data: data
    })
}

export function updateAssist(data) {
    return request({
        url: '/backend/activity/assist/update',
        method: 'post',
        data: data
    })
}

export function updateAssistOnline(data) {
    return request({
        url: '/backend/activity/assist/online',
        method: 'post',
        data: data
    })
}

export function assistDelete(data) {
    return request({
        url: '/backend/activity/assist/delete',
        method: 'post',
        data: data
    })
}